import { render, staticRenderFns } from "./AdminMapPoints.vue?vue&type=template&id=3d025ae5&scoped=true"
import script from "./AdminMapPoints.vue?vue&type=script&lang=js"
export * from "./AdminMapPoints.vue?vue&type=script&lang=js"
import style0 from "./AdminMapPoints.vue?vue&type=style&index=0&id=3d025ae5&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d025ae5",
  null
  
)

export default component.exports